import React from "react";
import ApiData from "../../../api/ApiData";
import { ItemClientIdAdmin } from "./ItemClientIdAdmin";
import { observer } from "mobx-react-lite";

export const ListClientIdAdmin = observer(({ deleteClient, gridClass }) => {
  return ApiData.soft_all.map((clientid) => (
    <ItemClientIdAdmin
      deleteClient={deleteClient}
      key={clientid.id}
      clientid={clientid}
      gridClass={gridClass}
    />
  ));
});
